export enum TransactionTypeEnum {
  SALE = "SALE",
  PRE_AUTH = "PRE_AUTH",
}
